
<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 5.96602C14.95 5.95769 14.8917 5.95769 14.8417 5.96602C13.6917 5.92435 12.775 4.98268 12.775 3.81602C12.775 2.62435 13.7334 1.66602 14.925 1.66602C16.1167 1.66602 17.075 2.63268 17.075 3.81602C17.0667 4.98268 16.15 5.92435 15 5.96602Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.1417 12.0328C15.2834 12.2245 16.5417 12.0245 17.425 11.4328C18.6 10.6495 18.6 9.36615 17.425 8.58282C16.5334 7.99115 15.2584 7.79115 14.1167 7.99115" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.97503 5.96602C5.02503 5.95769 5.08336 5.95769 5.13336 5.96602C6.28336 5.92435 7.20002 4.98268 7.20002 3.81602C7.20002 2.62435 6.24169 1.66602 5.05003 1.66602C3.85836 1.66602 2.90002 2.63268 2.90002 3.81602C2.90836 4.98268 3.82503 5.92435 4.97503 5.96602Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.83334 12.0328C4.69168 12.2245 3.43335 12.0245 2.55001 11.4328C1.37501 10.6495 1.37501 9.36615 2.55001 8.58282C3.44168 7.99115 4.71668 7.79115 5.85834 7.99115" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.99996 12.1926C9.94996 12.1842 9.89163 12.1842 9.84163 12.1926C8.69163 12.1509 7.77496 11.2092 7.77496 10.0426C7.77496 8.85091 8.7333 7.89258 9.92496 7.89258C11.1166 7.89258 12.075 8.85925 12.075 10.0426C12.0666 11.2092 11.15 12.1592 9.99996 12.1926Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.57498 14.8168C6.39998 15.6001 6.39998 16.8835 7.57498 17.6668C8.90831 18.5585 11.0916 18.5585 12.425 17.6668C13.6 16.8835 13.6 15.6001 12.425 14.8168C11.1 13.9335 8.90831 13.9335 7.57498 14.8168Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>
        
<script>
  export default {
    name: 'UserIcon',
    data() {
  return {
    
  }
  },
  computed: {
  },
    };
</script>
        